

 
<dashboardnav>

  <div  class="reference_body">
    <div class="pink_box"></div>
    <div class="green_box"></div>

    <!-- <pre>{{epimsgatesdata$ | async | json}}</pre> -->

 <mat-tab-group mat-align-tabs="end">
  <mat-tab>
   

    <ng-template mat-tab-label>
      <mat-icon >supervisor_account</mat-icon> Stakeholder Profiles
    </ng-template>
    <!-- <h1>Best pasta restaurants</h1>
    <p>...</p> -->

    <div class="row top_search sticky-nav" style="width: 95%">
     
      <div class="col-md-9">


       <input class="stakeholder_search"
                     type="text"
                     
                     placeholder="Search for Stakeholders" [(ngModel)]="searchvalue" (ngModelChange)="searchStakeholder()"
                 />

 
     
      </div>
      <div class="col-md-3" >
        <button class="top prmiary_button" (click)="addNewStakeholder()" >
          Add<em class="ti-plus"></em> 
        </button>

        
        <button class="top prmiary_button ml-4" (click)="OnSubmit()"  >
          Submit <em class="ti-plane"></em> 
        </button>
      </div>
 </div>

 <div *ngFor="let stakeholder of filteredstakeholders; let i = index">
  <div class="stakeholder_search-reuslts" style="cursor:pointer" (click)="selectStakeholder(stakeholder)">
    <div class="name d-inline-block"><em class="ti-user ml-2"></em> <h4 class="stakeholder_name d-inline-block">{{stakeholder.Title? stakeholder.Title.TitleName: ""}} {{stakeholder.Fullname}}</h4></div>
    <div class="phone_number d-inline-block"><em class="ti-mobile"></em> {{fullPhoneEmail(stakeholder,'phone')}}</div>
    <button mat-icon-button (click)="$event.stopImmediatePropagation()" [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item>
        <mat-icon>dialpad</mat-icon>
        <span>Edit</span>
      </button>
      <button mat-menu-item>
        <mat-icon>dialpad</mat-icon>
        <span>Interactions</span>
      </button>
      <button mat-menu-item disabled>
        <mat-icon>voicemail</mat-icon>
        <span>Complaints</span>
      </button>
      <button mat-menu-item>
        <mat-icon>notifications_off</mat-icon>
        <span>Task</span>
      </button>
      <button mat-menu-item>
        <mat-icon>notifications_off</mat-icon>
        <span>Correspondence</span>
      </button>
    </mat-menu>
    
    <div class="search_info">
      <h5>
        <span class="title"> <em class="ti-calendar"></em> Day/Month</span>
        <span class="answer">{{stakeholder.DOBShort}}</span>
      </h5>
      <h5>
        <span class="title"><em class="ti-flag-alt-2"></em> Party</span>
        <span class="answer">{{ stakeholder.PoliticalParty? stakeholder.PoliticalParty.PoliticalPartyName: ''}} </span>
      </h5>
      <h5>
        <span class="title"><em class="ti-target"></em> Club</span>
        <span class="answer">Manchester United</span>
      </h5>
      <h5>
        <span class="title"><em class="ti-email"></em> Email</span>
        <span class="answer">{{fullPhoneEmail(stakeholder,'email')}}</span>
      </h5>
    </div>
    <mat-accordion>

                  

     

      <mat-expansion-panel class="section">
        <mat-expansion-panel-header style="margin-bottom: 5px;" (click)="$event.stopImmediatePropagation()">
          <mat-panel-title  style="padding:3rem 0; color: green;">
            <span class=" mr-2"  > <em class="ti-layers"></em> </span>Details
          </mat-panel-title>
          <mat-panel-description>
           
          </mat-panel-description>
        </mat-expansion-panel-header>
    
        <mat-form-field class="contain mr-4" style="width:100%">
          <mat-label>First name</mat-label>
          <input matInput class="field">
        </mat-form-field>
    
        <mat-form-field class="contain mr-4" style="width:40%">
          <mat-label>Age</mat-label>
          <input matInput type="number" min="1" class="field">
        </mat-form-field>

        <span class="mr-4"><em class="ti-close mr-1" style="color:#000; font-weight: bold; cursor:pointer"></em> </span>
        <input type="checkbox" name="" id="">

      </mat-expansion-panel>

     
    </mat-accordion>
  </div>
 </div>


 <form [formGroup]="stakeholderForm"  >



  <main >

      <!-- <pre>{{stakeholders$ | async | json}}</pre> -->

   
 

    <div class="main">

        <!-- <div class="side_nav">

            <ul>
                <li>  <span><img src="/images/side_nav/User.svg" alt=""></span>Admin</li>  
                <li>  <span><img src="/images/side_nav/employee.svg" alt=""></span>Employees</li>  
                <li>  <span><img src="/images/side_nav/Calendar.svg" alt=""></span>Leave Management</li>  
                <li>  <span><img src="/images/side_nav/Import.svg" alt=""></span>Recruitment</li>  
                <li>  <span><img src="/images/side_nav/Import.svg" alt=""></span>Payroll</li>  
                <li>  <span><img src="/images/side_nav/icons8-alarm-clock-50.svg" alt=""></span>Time Manegement</li>  
                <li>  <span><img src="/images/side_nav/icons8-airplane-take-off-50.svg" alt=""></span>Travel
                    Management
                </li>  
                <li>  <span><img src="/images/side_nav/icons8-data-sheet-50.svg" alt=""></span>Performance</li>  
                <li>  <span><img src="/images/side_nav/icons8-company-50.svg" alt=""></span>Company</li>  
            </ul>
        </div> -->



        <div class="employee_profile">

            <!-- <div class="info">

                <div class="leave_detail">
                    <h5>
                        <span class="available">5</span>
                        <span class="info_name green">Leave Request</span>
                        <span class="sub_info"> Available</span>
                    </h5>
                </div>

                <div class="leave_detail">
                    <h5>
                        <span class="available">4</span>
                        <span class="info_name peach">Cancellation Request</span>
                        <span class="sub_info"> Available</span>
                    </h5>
                </div>

                <div class="leave_detail">
                    <h5>
                        <span class="available">5</span>
                        <span class="info_name orange">Approval Request</span>
                        <span class="sub_info"> Available</span>
                    </h5>
                </div>
            </div> -->


            <div class="primary_information-card large_height" [ngClass]="setShadowClasses()">
              <div class="icons">
                <div class="chat"><button><img src="./assets/images/user_img/Chat.svg" class="chat-btn" height="18px"
                            alt="">Message</button></div>
                <div class="edit"><button><em class="ti-pencil"></em> Edit</button></div>
                <img src="/assets/images/components/long_curve.svg" alt="" class="top_curve">
                <img src="/assets/images/components/little_balls.svg" alt="" class="box">
                <img src="/assets/images/components/short_curve.svg" alt="" class="short_curve">
            </div> 
                <!-- top buttons and designs ----===================================== top buttons and designs -->


                <div class="staff_info">
                    <div class="image"></div>
                    <div class="name">
                        <h5 class="staff_name">{{ stakeholderForm.value.Fullname}}</h5>
                        <!-- <p class="dept">I.T Department (Programmer)</p> -->
                        <p class="dept">{{fullPhoneEmail(stakeholderForm.value,'phone')}}</p>
                    </div>

                    <div class="other_details" >
                      
                            <div class="info_input"  >
                              <label >Title</label>
                              
                                <!-- <mat-label>Title</mat-label> -->
                                <select  formControlName="TitleId">
                                  <option *ngFor="let title of titles" [value]="title.id"  >
                                    {{title.Name}}
                                  </option>
                                </select>
                              
                            </div>

                          
                            <div class="info_input" style="margin-top: 8px">
                              <label for="">First Name</label>
                              <input type="text" name="name" id="name" class="email" formControlName="Fullname" >
                          </div>
                          <div class="info_input" style="margin-top: 8px">
                            <label for="">Last Name (Surname) </label>
                            <input type="text" name="name" id="name" class="email" formControlName="Fullname" >
                        </div>
                            <div class="info_input" style="margin-top: 8px">
                                <label for="">Birthday (Day/Month)</label>
                                <input type="text" name="dob" id="dob" class="email" formControlName="DOBShort">
                            </div>
                            <!-- <div class="info_input" style="margin-top: 8px">
                              <label for="">Age</label>
                              <input type="text" name="age" id="age" class="email" formControlName="DOBShort">
                          </div> -->
                            <div class="info_input" style="margin-top: 8px">

                              <!-- <mat-form-field >
                                <mat-label>Political Party</mat-label>
                                <mat-select  formControlName="PoliticalPartyId"  >
                                  <mat-option *ngFor="let party of politicalparties" [value]="party.id"  >
                                    {{party.Name}}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field> -->

                              <label>Political Party</label>
                                <select  formControlName="PoliticalPartyId"  >
                                  <option *ngFor="let party of politicalparties" [value]="party.id"  >
                                    {{party.Name}}
                                  </option>
                                </select>
                                <!-- <label for="">Political Party</label>
                                <Select class="sex" style="width: 90%">
                                    <option value="">--select party--</option>
                                </Select> -->
                            </div>
                          

                            <div class="info_input" style="text-align: center; margin: 0; padding:0;">
                              <button class="top prmiary_button" style="margin-top: 15px; box-shadow: none;" (click)="OnSubmit()"  >
                                Submit <em class="ti-plane"></em> 
                              </button>
                            </div>
                            

                        
                    </div>

                </div>


            </div>


            <div class="main_info">
                <div class="input_card">
                    <label for="">Description</label>
                    <textarea name="" id="" cols="130" rows="5" class="description" formControlName="StakeholderDesc"
                        placeholder="Enter description"></textarea>
                </div>

                <div class="input_card">

                  <section class="example-section">
                    <label class="example-margin">Gender:</label>
                    <mat-radio-group   formControlName="Gender">
                      <mat-radio-button class="example-margin" value="Male">Male</mat-radio-button>
                      <mat-radio-button class="example-margin" value="Female" >Female</mat-radio-button>
                      <mat-radio-button class="example-margin" value="Other" >Other</mat-radio-button>
                    </mat-radio-group>
                  </section>

                  <section class="example-section">
                    <label class="example-margin">Language Spoken:</label>
                    <mat-checkbox class="example-margin" >English</mat-checkbox>
                    <mat-checkbox class="example-margin" >Spain</mat-checkbox>
                    <mat-checkbox class="example-margin" >Korea</mat-checkbox>
                  </section>

                  <section class="example-section">
                    <label class="example-margin">Level Influence:</label>
                    <mat-slider thumbLabel min="1" max="5" step="0.5" value="1.5" formControlName="LevelOfInfluence"></mat-slider> <span> {{ stakeholderForm.value.LevelOfInfluence}}</span>
                  </section>

                  <section class="example-section">
                    <label class="example-margin">Level of Interest:</label>
                    <mat-slider thumbLabel  min="1" max="5" step="0.5" value="1.5" formControlName="LevelOfInterest"></mat-slider> <span> {{ stakeholderForm.value.LevelOfInterest}}</span>
                  </section>
                  <section class="example-section">
                    <label class="example-margin">Level of Impact:</label>
                    <mat-slider thumbLabel min="1" max="5" step="0.5" value="1.5" formControlName="LevelOfImpact"></mat-slider> <span> {{ stakeholderForm.value.LevelOfImpact}}</span>
                  </section>
                  <section class="example-section">
                    <label class="example-margin">Relationship Rating:</label>
                    <mat-slider thumbLabel min="1" max="5" step="0.5" value="1.5" formControlName="RelationshipRating"></mat-slider> <span> {{ stakeholderForm.value.RelationshipRating}}</span>
                  </section>


                  
                 
                </div>

                <mat-accordion>

                  

                  <mat-expansion-panel class="section" formArrayName="stakeholderContacts">
                    <mat-expansion-panel-header style="margin-bottom: 5px;">
                      <mat-panel-title style="padding:3rem 0;">
                        <mat-icon style="color: orange">email</mat-icon> Contacts  <span (click)="addStakeholderContact(); $event.stopImmediatePropagation()"> <em class="ti-plus ml-2"></em> </span>
                      </mat-panel-title>
                      <mat-panel-description>
                       
                      </mat-panel-description>
                    </mat-expansion-panel-header>

                    <div *ngFor="
                    let stakeholdercontact of stakeholderForm.get('stakeholderContacts')['controls'];
                    index as i
                  " [formGroupName]="i">

                   
                    <mat-form-field class="contain mr-4" style="width:40%">
                      <mat-label>Value</mat-label>
                      <input matInput formControlName="StakeholderContactValue">
                    </mat-form-field>
                
                 

                    <mat-form-field class="contain mr-4" style="width:40%">
                      <!-- <mat-label>Contact Type</mat-label>
                      <mat-select>
                        <mat-option *ngFor="let contacttype of contactTypes" [value]="contacttype.value">
                          {{contacttype.viewValue}}
                        </mat-option>
                      </mat-select> -->

                      <mat-label>Contact Type</mat-label>
                      <mat-select  formControlName="ContactTypeId" >
                        <mat-option *ngFor="let contacttype of contacttypes" [value]="contacttype.id"  >
                          {{contacttype.Name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                
                   

                    <span class="mr-4" (click)="deleteStakeholderContact($event,i, stakeholdercontact.value)"><em class="ti-close mr-1" style="color:#000; font-weight: bold; cursor:pointer"></em> </span>
                    <mat-checkbox class="example-margin" ></mat-checkbox>
                  </div>
                  </mat-expansion-panel>
                  <mat-expansion-panel class="section" formArrayName="stakeholderPostalAddresses">
                    <mat-expansion-panel-header style="margin-bottom: 5px;">
                      <mat-panel-title style="padding:3rem 0;">
                        <mat-icon style="color: orange">location_on</mat-icon> Postal Address  <span (click)="addStakeholderPostalAddress(); $event.stopImmediatePropagation()"> <em class="ti-plus ml-2"></em> </span>
                      </mat-panel-title>
                      <mat-panel-description>
                       
                      </mat-panel-description>
                    </mat-expansion-panel-header>


                    <div *ngFor="
                    let stakeholderpostaladdress of stakeholderForm.get('stakeholderPostalAddresses')['controls'];
                    index as j
                  "  class="row">

                  <div [formGroupName]="j" class="mr-4 col-10">

                    
                  
                  <div class="row" style="width:100%;">
                       <div class="col-md-10">
                        <label for="" class="d-block">Address 1</label>
                        <input matInput class="field"  formControlName="StakeholderPostalAddressFirst">
                       </div>
                  </div>
                  <div class="row" style="width:100%;">
                    <div class="col-md-10">
                     <label for="">Address 2</label>
                     <input matInput class="field" formControlName="StakeholderPostalAddressSecond">
                    </div>
               </div>

               <!-- <div class="row">
                   <div class="col-md-12">
                    <span class="head" style="margin-left: 15px;" >Select LGA: <mat-form-field>
               
                      <mat-label>Type</mat-label>
                      <mat-select    >
                        <mat-option *ngFor="let country of countries$ | async" [value]="country.id"  >
                          {{country.CountryName}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field></span>
                   </div>
               </div>

               <div class="row">
                   <div class="col-md-12">
                    <mat-form-field>
                      <mat-label>Select book</mat-label>  
                      <mat-select>

                        <mat-optgroup label="One level deep">
                          <mat-option>
                              One level deep
                          </mat-option>
                      </mat-optgroup>
                      <mat-optgroup label="Another group">
                          <mat-optgroup flex-offset="5" label="Second level deep">
                
                              <mat-optgroup flex-offset="5" label="3 deep now and we want to see what happens with long text">
                                <mat-option>Some more options</mat-option>
                              </mat-optgroup>
                
                              <mat-option>Two levels deep</mat-option>
                              <mat-option>Two levels deep again</mat-option>
                
                          </mat-optgroup>
                      </mat-optgroup>



                        <mat-option>-- None --</mat-option>
                        <mat-optgroup flex-offset="5" label="Epic">
                          
                         
                          <mat-optgroup flex-offset="5" label="Epic2 new">
                            <mat-option value="Ramayana2">Ramayana</mat-option>
                            <mat-option value="Mahabharata2">Mahabharata</mat-option>
                          </mat-optgroup>
                        </mat-optgroup>
                        <mat-optgroup label="Science">
                          <mat-option value="Physics">Physics</mat-option>
                          <mat-option value="Chemistry">Chemistry</mat-option>
                        </mat-optgroup>
                        <mat-optgroup label="Novel">
                          <mat-option value="Godan">Godan</mat-option>
                          <mat-option value="Karmbhumi">Karmbhumi</mat-option>
                        </mat-optgroup>  
                      </mat-select>
                    </mat-form-field> 
                   </div>
               </div> -->

              </div>
                   
                   

                    <span class="mr-1" (click)="deleteStakeholderPostalAddress($event,j, stakeholderpostaladdress.value)"><em class="ti-close" style="color:#000; font-weight: bold; cursor:pointer"></em> </span>
                    <mat-checkbox class="example-margin " ></mat-checkbox>
                  </div>
                
                    

                  </mat-expansion-panel>
                  <mat-expansion-panel class="section" formArrayName="stakeholderSocialMedias">
                    <mat-expansion-panel-header style="margin-bottom: 5px;">
                      <mat-panel-title style="padding:3rem 0;">
                        <mat-icon style="color: orange">group</mat-icon> Social Media  <span (click)="addStakeholderSocialMedia(); $event.stopImmediatePropagation()"> <em class="ti-plus ml-2"></em> </span>
                      </mat-panel-title>
                      <mat-panel-description>
                       
                      </mat-panel-description>
                    </mat-expansion-panel-header>
                
                     
                    <div *ngFor="
                    let stakeholdersocialmedia of stakeholderForm.get('stakeholderSocialMedias')['controls'];
                    index as m
                  "  [formGroupName]="m">

          
                    <mat-form-field class="contain mr-4" style="width:40%">
                      <mat-label>Value</mat-label>
                      <input matInput formControlName="StakeholderSocialMediaValue">
                    </mat-form-field>
                
                 

                    <mat-form-field class="contain mr-4" style="width:40%">
                      <!-- <mat-label>Contact Type</mat-label>
                      <mat-select>
                        <mat-option *ngFor="let contacttype of contactTypes" [value]="contacttype.value">
                          {{contacttype.viewValue}}
                        </mat-option>
                      </mat-select> -->

                      <mat-label>Social Media Type</mat-label>
                      <mat-select  formControlName="SocialMediaTypeId" >
                        <mat-option *ngFor="let socialmediatype of socialmediatypes" [value]="socialmediatype.id"  >
                          {{socialmediatype.Name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                
                   
            
                    <span class="mr-4" (click)="deleteStakeholderSocialMedia($event,m, stakeholdersocialmedia.value)"><em class="ti-close mr-1" style="color:#000; font-weight: bold; cursor:pointer"></em> </span>
                    <mat-checkbox class="example-margin" ></mat-checkbox>
                  </div>

                  </mat-expansion-panel>
                  <mat-expansion-panel class="section" style="position: relative;" formArrayName="stakeholderOrganizations">
                    <mat-expansion-panel-header style="margin-bottom: 5px;">
                      <mat-panel-title style="padding:3rem 0;">
                        <mat-icon style="color: orange">meeting_room</mat-icon>  Organizations  <span (click)="addStakeholderOrganization(); $event.stopImmediatePropagation()"> <em class="ti-plus ml-2"></em> </span>
                      </mat-panel-title>
                      <mat-panel-description>
                       
                      </mat-panel-description>
                    </mat-expansion-panel-header>
                

                      <!-- <mat-select class="field contain mr-4" formControlName="SocialMediaTypeId" style="width:36%; height:2rem; display:inline-block;">  
                        <mat-option *ngFor="let socialmediatype of socialmediatypes" [value]="socialmediatype.id"  >
                          {{socialmediatype.Name}}
                        </mat-option>
                      </mat-select> -->
                 
                      <div *ngFor="
                      let stakeholderorganization of stakeholderForm.get('stakeholderOrganizations')['controls'];
                      index as n
                    "  [formGroupName]="n">

                    <mat-form-field class="contain mr-4" style="width:40%; height:2rem;">
                      <mat-select class="field contain mr-4" formControlName="OrganizationId">  
                        <mat-option *ngFor="let organization of organizations" [value]="organization.id"  >
                          {{organization.Name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                
                    <mat-form-field class="contain mr-4" style="width:40%">
                      <mat-label>Description</mat-label>
                      <input matInput class="field" formControlName="StakeholderOrganizationDesc">
                    </mat-form-field>
                
                    <mat-form-field class="contain mr-4" style="width:40%">
                      <mat-label>Position</mat-label>
                      <input matInput class="field" formControlName="PositionName">
                    </mat-form-field>
                
                    <mat-form-field class="contain mr-4" style="width:40%">
                      <mat-label>Division</mat-label>
                      <input matInput class="field" formControlName="DivisionName">
                    </mat-form-field>


                    <span class="mr-4" (click)="deleteStakeholderOrganization($event,n, stakeholderorganization.value)"><em class="ti-close mr-1" style="color:#000; font-weight: bold; cursor:pointer;"></em> </span>
                  </div>
                  </mat-expansion-panel>

                  <mat-expansion-panel class="section">
                    <mat-expansion-panel-header style="margin-bottom: 5px;">
                      <mat-panel-title style="padding:3rem 0;">
                        Interactions  <span> <em class="ti-plus ml-2"></em> </span>
                      </mat-panel-title>
                      <mat-panel-description>
                       
                      </mat-panel-description>
                    </mat-expansion-panel-header>
                
                    <mat-form-field class="contain mr-4" style="width:40%">
                      <mat-label>First name</mat-label>
                      <input matInput class="field">
                    </mat-form-field>
                
                    <mat-form-field class="contain mr-4" style="width:40%">
                      <mat-label>Age</mat-label>
                      <input matInput type="number" min="1" class="field">
                    </mat-form-field>

                    <span class="mr-4"><em class="ti-close mr-1" style="color:#000; font-weight: bold; cursor:pointer"></em> </span>
                    <input type="checkbox" name="" id="">
                 

                  </mat-expansion-panel>

                  <mat-expansion-panel class="section" formArrayName="stakeholderAreaOfInterests">
                    <mat-expansion-panel-header style="margin-bottom: 5px;">
                      <mat-panel-title style="padding:3rem 0;">
                        <mat-icon style="color: orange">nature_people</mat-icon>   Area of Interest  <span (click)="addStakeholderAreaOfInterest(); $event.stopImmediatePropagation()"> <em class="ti-plus ml-2"></em> </span>
                      </mat-panel-title>
                      <mat-panel-description>
                       
                      </mat-panel-description>
                    </mat-expansion-panel-header>
                
                    
                    <div *ngFor="
                    let stakeholderareaofinterest of stakeholderForm.get('stakeholderAreaOfInterests')['controls'];
                    index as o
                  " [formGroupName]="o">

                   
                   
                
                 

                    <mat-form-field class="contain mr-8" style="width:40%">
                      <!-- <mat-label>Contact Type</mat-label>
                      <mat-select>
                        <mat-option *ngFor="let contacttype of contactTypes" [value]="contacttype.value">
                          {{contacttype.viewValue}}
                        </mat-option>
                      </mat-select> -->

                      <mat-label>Area of Interest</mat-label>
                      <mat-select  formControlName="AreaOfInterestId" >
                        <mat-option *ngFor="let areainterest of areaofinterests" [value]="areainterest.id"  >
                          {{areainterest.Name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                
                   

                    <span class="mr-4" (click)="deleteStakeholderAreaOfInterest($event,o, stakeholderareaofinterest.value)"><em class="ti-close mr-1" style="color:#000; font-weight: bold; cursor:pointer"></em> </span>
                    <!-- <mat-checkbox class="example-margin" ></mat-checkbox> -->
                  </div>

                  </mat-expansion-panel>


                  <mat-expansion-panel class="section" formArrayName="stakeholderClubs">
                    <mat-expansion-panel-header style="margin-bottom: 5px;">
                      <mat-panel-title style="padding:3rem 0;">
                        <mat-icon style="color: orange">sports_soccer</mat-icon>  Football Clubs <span (click)="addStakeholderClubs(); $event.stopImmediatePropagation()"> <em class="ti-plus ml-2"></em> </span>
                      </mat-panel-title>
                      <mat-panel-description>
                       
                      </mat-panel-description>
                    </mat-expansion-panel-header>
                
                       
                    <div *ngFor="
                    let stakeholderclub of stakeholderForm.get('stakeholderClubs')['controls'];
                    index as p
                  " [formGroupName]="p">

                   
                   
                
                 

                    <mat-form-field class="contain mr-8" style="width:40%">
                      <!-- <mat-label>Contact Type</mat-label>
                      <mat-select>
                        <mat-option *ngFor="let contacttype of contactTypes" [value]="contacttype.value">
                          {{contacttype.viewValue}}
                        </mat-option>
                      </mat-select> -->

                      <mat-label>Football Club</mat-label>
                      <mat-select  formControlName="ClubId" >
                        <mat-option *ngFor="let club of clubs" [value]="club.id"  >
                          {{club.Name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                
                   

                    <span class="mr-4" (click)="deleteStakeholderClubs($event,p, stakeholderclub.value)"><em class="ti-close mr-1" style="color:#000; font-weight: bold; cursor:pointer"></em> </span>
                    <!-- <mat-checkbox class="example-margin" ></mat-checkbox> -->
                  </div>

                  </mat-expansion-panel>
                  <mat-expansion-panel class="section">
                    <mat-expansion-panel-header style="margin-bottom: 5px;">
                      <mat-panel-title style="padding:3rem 0;">
                        Grouping <span> <em class="ti-plus ml-2"></em> </span>
                      </mat-panel-title>
                      <mat-panel-description>
                       
                      </mat-panel-description>
                    </mat-expansion-panel-header>
                
                    

                  </mat-expansion-panel>

                  <mat-expansion-panel class="section">
                    <mat-expansion-panel-header style="margin-bottom: 5px;">
                      <mat-panel-title style="padding:3rem 0;">
                        Link to Another Stakeholder <span> <em class="ti-plus ml-2"></em> </span>
                      </mat-panel-title>
                      <mat-panel-description>
                       
                      </mat-panel-description>
                    </mat-expansion-panel-header>
                
                  

                  </mat-expansion-panel>

                  <mat-expansion-panel class="section" formArrayName="stakeholderPropertys">
                    <mat-expansion-panel-header style="margin-bottom: 5px;">
                      <mat-panel-title style="padding:3rem 0;">
                        <mat-icon style="color: orange">location_city</mat-icon>  Property <span (click)="addStakeholderProperty(); $event.stopImmediatePropagation()"> <em class="ti-plus ml-2"></em> </span>
                      </mat-panel-title>
                      <mat-panel-description>
                       
                      </mat-panel-description>
                    </mat-expansion-panel-header>
                
                    <div *ngFor="
                    let stakeproperty of stakeholderForm.get('stakeholderPropertys')['controls'];
                    index as q
                  " [formGroupName]="q">

                   
                   
                
                 

                    <mat-form-field class="contain mr-8" style="width:40%">
                      <!-- <mat-label>Contact Type</mat-label>
                      <mat-select>
                        <mat-option *ngFor="let contacttype of contactTypes" [value]="contacttype.value">
                          {{contacttype.viewValue}}
                        </mat-option>
                      </mat-select> -->

                      <mat-label>Property</mat-label>
                      <mat-select  formControlName="PropertyId" >
                        <mat-option *ngFor="let propnew of propertys" [value]="propnew.id"  >
                          {{propnew.Name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                
                   

                    <span class="mr-4" (click)="deleteStakeholderPropertys($event,q, stakeproperty.value)"><em class="ti-close mr-1" style="color:#000; font-weight: bold; cursor:pointer"></em> </span>
                    <!-- <mat-checkbox class="example-margin" ></mat-checkbox> -->
                  </div>

                  </mat-expansion-panel>

                  <mat-expansion-panel class="section">
                    <mat-expansion-panel-header style="margin-bottom: 5px;">
                      <mat-panel-title style="padding:3rem 0;">
                        Complaints <span> <em class="ti-plus ml-2"></em> </span>
                      </mat-panel-title>
                      <mat-panel-description>
                       
                      </mat-panel-description>
                    </mat-expansion-panel-header>
                
                   

                  </mat-expansion-panel>
                  <mat-expansion-panel class="section">
                    <mat-expansion-panel-header style="margin-bottom: 5px;">
                      <mat-panel-title style="padding:3rem 0;">
                        Task <span> <em class="ti-plus ml-2"></em> </span>
                      </mat-panel-title>
                      <mat-panel-description>
                       
                      </mat-panel-description>
                    </mat-expansion-panel-header>
                
                   

                  </mat-expansion-panel>



                 
                </mat-accordion>

             
            
             

            </div>



        </div>


    </div>


</main>
</form>
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>
      <mat-icon>contact_phone</mat-icon> Engagements
    </ng-template>
    <!-- <h1>Terrible sushi restaurants</h1>
    <p>...</p> -->

    <div class="row top_search sticky-nav" style="width: 95%">
     
      <div class="col-md-9">


       <input class="stakeholder_search"
                     type="text"
                     
                     placeholder="Search for Engagements" [(ngModel)]="searchEngagementvalue" (ngModelChange)="searchEngagment()"
                 />

 
     
      </div>
      <div class="col-md-3" >
        <button class="top prmiary_button" (click)="addNewEngagement()" >
          Add<em class="ti-plus"></em> 
        </button>

        
        <button class="top prmiary_button ml-4" (click)="OnSubmitEngagement()"  >
          Submit <em class="ti-plane"></em> 
        </button>
      </div>
 </div>

 <div *ngFor="let engagement of filteredengagements; let i = index">
  <div class="stakeholder_search-reuslts" style="cursor:pointer" (click)="selectEngagement(engagement)">
    <div class="name d-inline-block"><em class="ti-user ml-2"></em> <h4 class="stakeholder_name d-inline-block"> {{engagement.EngagementTitle}}</h4></div>
    <div class="phone_number d-inline-block"><em class="ti-mobile"></em> 00202873743, 77373838</div>
    <button (click)="$event.stopImmediatePropagation()" mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item>
        <mat-icon>dialpad</mat-icon>
        <span>Edit</span>
      </button>
      <button mat-menu-item>
        <mat-icon>dialpad</mat-icon>
        <span>Interactions</span>
      </button>
      <button mat-menu-item disabled>
        <mat-icon>voicemail</mat-icon>
        <span>Complaints</span>
      </button>
      <button mat-menu-item>
        <mat-icon>notifications_off</mat-icon>
        <span>Task</span>
      </button>
      <button mat-menu-item>
        <mat-icon>notifications_off</mat-icon>
        <span>Correspondence</span>
      </button>
    </mat-menu>
    
    <div class="search_info">
      <h5>
        <span class="title"> <em class="ti-calendar"></em> Date</span>
        <span class="answer">{{engagement.EngagementProposedDate | date}}</span>
      </h5>
      <h5>
        <span class="title"><em class="ti-flag-alt-2"></em> Date held</span>
        <span class="answer">{{ engagement.EngagementDate | date}} </span>
      </h5>
      <h5>
        <span class="title"><em class="ti-target"></em> </span>
        <span class="answer"></span>
      </h5>
      <h5>
        <span class="title"><em class="ti-email"></em> Email</span>
        <span class="answer"></span>
      </h5>
    </div>
    <mat-accordion>

                  

     

      <mat-expansion-panel class="section">
        <mat-expansion-panel-header style="margin-bottom: 5px;" (click)="$event.stopImmediatePropagation()">
          <mat-panel-title style="padding:3rem 0; color: green;" >
            <span class=" mr-2"> <em class="ti-layers"></em> </span>Details
          </mat-panel-title>
          <mat-panel-description>
           
          </mat-panel-description>
        </mat-expansion-panel-header>
    
        <mat-form-field class="contain mr-4" style="width:40%">
          <mat-label>First name</mat-label>
          <input matInput class="field">
        </mat-form-field>
    
        <mat-form-field class="contain mr-4" style="width:40%">
          <mat-label>Age</mat-label>
          <input matInput type="number" min="1" class="field">
        </mat-form-field>

        <span class="mr-4"><em class="ti-close mr-1" style="color:#000; font-weight: bold; cursor:pointer"></em> </span>
        <input type="checkbox" name="" id="">

      </mat-expansion-panel>

     
    </mat-accordion>
  </div>
 </div>

 
 <div class="input_card section">

  <form [formGroup]="stakeholderEngagementForm" *ngIf="isShowEngagementForm"  >
  <div class="main_info">

    <div class="row">
      <div class="col-md-6">
        <div class="input_card">
          <label for="">Title</label>
          <input type="text" name="" id="" cols="130"  class="description" 
              placeholder="Enter description" formControlName="EngagementTitle"/>
        </div>
      </div>
  
      <div class="col-md-6">
        <div class="input_card" style="width: 90%;">
          <label for="">Proposed Date</label>
          <input type="date" name="" id="" cols="130"  class="description" 
              placeholder="Proposed Date" formControlName="EngagementTitle"/>
        </div>
      </div>
      
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="input_card">
          <label for="">Description</label>
          <textarea name="" id="" cols="130" rows="3" class="description" 
              placeholder="Enter description" formControlName="EngagementTitle"></textarea>
        </div>
      </div>
      
    </div>
  
    <div class="row">
      <div class="col-md-6">
        <div class="input_card">
          <label for="">Objective</label>
          <textarea name="" id="" cols="130" rows="3" class="description" 
              placeholder="Enter description" formControlName="EngagementObjective"></textarea>
        </div>
      </div>
  
      <div class="col-md-6">
        <div class="input_card" style="width: 90%;">
          <label for="">Value at Stake</label>
          <textarea name="" id="" cols="130" rows="3" class="description" 
              placeholder="Enter Value At Stake" formControlName="EngagementValueAtStake"></textarea>
        </div>
      </div>
      
    </div>

    <div class="row">
        <div class="col-md-12">
          <section class="example-section">
            <label class="example-margin">Business Theme:</label>

            <div *ngFor="let theme of businessThemes">
              <mat-checkbox class="example-margin"   [(checked)]= "theme.ischecked" (change)="toggle($event,theme.id)">{{theme.name}}</mat-checkbox>
            </div>
           
            <!-- <mat-checkbox class="example-margin" >Commercial</mat-checkbox>
            <mat-checkbox class="example-margin" >Project</mat-checkbox> -->
          </section>
        </div>
    </div>
  
  
    <div class="row">
      <div class="col-md-12">
        <mat-accordion>
          <mat-expansion-panel class="section" >
            <mat-expansion-panel-header style="margin-bottom: 5px;">
              <mat-panel-title style="padding:3rem 0;">
                <mat-icon style="color: orange">supervisor_account</mat-icon> Categorise
              </mat-panel-title>
              <mat-panel-description>
               
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div class="row">
              <div class="col-md-3">
                <mat-form-field>
                  <mat-label>Line of Business</mat-label>
                  <mat-select formControlName="EngagementLineOfBusinessId">
                    <mat-option *ngFor="let busiline of lineOfBusinesses" [value]="busiline.id">
                      {{busiline.Name}}
                    </mat-option>
                  </mat-select>

                 
                </mat-form-field>
              </div>
              <div class="col-md-3">
                <mat-form-field>
                  <mat-label>Type</mat-label>
                  <mat-select formControlName="EngagementTypeId">
                    <mat-option *ngFor="let engType of engagementTypes" [value]="engType.id">
                      {{engType.Name}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-md-3">
                <mat-form-field>
                  <mat-label>Category</mat-label>
                  <mat-select formControlName="EngagementCategoryId">
                    <mat-option *ngFor="let engCat of engagementCategories" [value]="engCat.id">
                      {{engCat.Name}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-md-3">
                <mat-form-field>
                  <mat-label>Stakeholder Group</mat-label>
                  <mat-select formControlName="EngagementGroupId">
                    <mat-option *ngFor="let food of foods" [value]="food.value">
                      {{food.viewValue}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-md-3">
                <mat-form-field>
                  <mat-label>Engagement Driver</mat-label>
                  <mat-select formControlName="EngagementDriverId">
                    <mat-option *ngFor="let engDriver of engagementDrivers" [value]="engDriver.id">
                      {{engDriver.Name}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-md-3">
                <mat-form-field>
                  <mat-label>Company</mat-label>
                  <mat-select formControlName="EngagementCompanyId">
                    <mat-option *ngFor="let comp of companies" [value]="comp.id">
                      {{comp.Name}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
        
        
             
           
  
          </mat-expansion-panel>
        </mat-accordion>
      </div>
      
    </div>
  
    <div class="row">
      <div class="col-md-12">
        <mat-accordion>
          <mat-expansion-panel class="section" >
            <mat-expansion-panel-header style="margin-bottom: 5px;">
              <mat-panel-title style="padding:3rem 0;">
                <mat-icon style="color: orange">supervisor_account</mat-icon> Responsible Persons <span (click)=" $event.stopImmediatePropagation()"> <em class="ti-plus ml-2"></em> </span>
              </mat-panel-title>
              <mat-panel-description>
               
              </mat-panel-description>
            </mat-expansion-panel-header>
        
             
           
  
          </mat-expansion-panel>
        </mat-accordion>
      </div>
      
    </div>
  
    <div class="row">
      <div class="col-md-12">
        <mat-accordion>
          <mat-expansion-panel class="section" >
            <mat-expansion-panel-header style="margin-bottom: 5px;">
              <mat-panel-title style="padding:3rem 0;">
                <mat-icon style="color: orange">supervisor_account</mat-icon> Stakeholders 
              </mat-panel-title>
              <mat-panel-description>
               
              </mat-panel-description>
            </mat-expansion-panel-header >
        
            <div class="row">
                 <div class="col-md-12">
                  <mrsoftapps-stakeholdersearch (selectedStakeholder)="selectStakeholderEngagement($event)">
                  </mrsoftapps-stakeholdersearch>
                 </div>
            </div>

            <div formArrayName="engagementStakeholders"  >
              <div *ngFor="
              let engagementStakeholder of stakeholderEngagementForm.get('engagementStakeholders')['controls'];
              index as q
            " [formGroupName]="q">
   
            <div class="adjustment" >
                
             
           


              <div class="">
               

               <!-- <Label>Name</Label> -->

               {{engagementStakeholder.value.StakeholderName}}
           
            

               
              </div>
              <div class="">
               <section class="example-section">
                 <label class="example-margin">Influence:</label>
                 <mat-slider thumbLabel min="1" max="5" step="0.5" value="1.5" formControlName="StakeholderInfluence" ></mat-slider> <span> {{engagementStakeholder.value.StakeholderInfluence}}</span>
               </section>
              </div>
              <div class="">
               <mat-form-field  style="width:100%">
                 <mat-label>Comments</mat-label>
                 <input matInput formControlName="StakeholderComments">
               </mat-form-field>
              </div>
              <div class="">
               <span (click)="deleteEngagementStakeholder($event,q, engagementStakeholder.value)" ><em class="ti-close mr-1" style="color:#000; font-weight: bold; cursor:pointer"></em> </span>
              </div>

             
         </div>

                </div>
            </div>
           
           
           
  
          </mat-expansion-panel>
        </mat-accordion>
      </div>
      
    </div>
  
    <div class="row">
      <div class="col-md-12">
        <mat-accordion>
          <mat-expansion-panel class="section"  formArrayName="engagementThirdPartyReps">
            <mat-expansion-panel-header style="margin-bottom: 5px;">
              <mat-panel-title style="padding:3rem 0;">
                <mat-icon style="color: orange">supervisor_account</mat-icon> Third Party and Representatives <span (click)="addEngagementReps(); $event.stopImmediatePropagation()"> <em class="ti-plus ml-2"></em> </span>
              </mat-panel-title>
              <mat-panel-description>
               
              </mat-panel-description>
            </mat-expansion-panel-header>
        
            <div *ngFor="
            let engagementReps of stakeholderEngagementForm.get('engagementThirdPartyReps')['controls'];
            index as x
          " [formGroupName]="x">
 
          <div class="adjustment" >
              
           
         


            <div class="">
             

             <!-- <Label>Name</Label> -->

             <mat-form-field  style="width:100%">
              <mat-label>Name</mat-label>
              <input matInput formControlName="EngagementThirdPartyRepName">
            </mat-form-field>
         
          

             
            </div>
            <div class="">
              <mat-form-field  style="width:100%">
                <mat-label>Phone Number</mat-label>
                <input matInput formControlName="EngagementThirdPartyRepPhone">
              </mat-form-field>
            </div>
            <div class="">
              <mat-form-field  style="width:100%">
                <mat-label>Email</mat-label>
                <input matInput formControlName="EngagementThirdPartyRepEmail">
              </mat-form-field>
            </div>
            <div class="">
             <mat-form-field  style="width:100%">
               <mat-label>Comments</mat-label>
               <input matInput formControlName="EngagementThirdPartyRepRemarks">
             </mat-form-field>
            </div>
            <div class="">
             <span (click)="deleteEngagementReps($event,x, engagementReps.value)" ><em class="ti-close mr-1" style="color:#000; font-weight: bold; cursor:pointer"></em> </span>
            </div>

           
       </div>

              </div>
           
  
          </mat-expansion-panel>
        </mat-accordion>
      </div>
      
    </div>

    <div class="row">
      <div class="col-md-12">
        <mat-accordion>
          <mat-expansion-panel class="section"  formArrayName="engagementThirdPartyReps">
            <mat-expansion-panel-header style="margin-bottom: 5px;">
              <mat-panel-title style="padding:3rem 0;">
                <mat-icon style="color: orange">supervisor_account</mat-icon> Documents <span > <em class="ti-plus ml-2"></em> </span>
              </mat-panel-title>
              <mat-panel-description>
               
              </mat-panel-description>
            </mat-expansion-panel-header>
        
           <mrsoftapps-documents [OriginatingModule]="engagementModule" [OriginatedModuleSpecificId]="engagementModuleSpecificId"
             [SubmitIsTriggerByparent]="SubmitIsTriggerByparent">

           </mrsoftapps-documents>
           
  
          </mat-expansion-panel>
        </mat-accordion>
      </div>
      
    </div>
  
   
    
  
   </div>
  </form>
 </div>
 

 
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>
      <mat-icon>chat</mat-icon>  Interactions
    </ng-template>
    <!-- <h1>Terrible sushi restaurants</h1> -->
    <p>...</p>
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>
      <mat-icon>message</mat-icon>  Complaints
    </ng-template>
    <!-- <h1>Terrible sushi restaurants</h1> -->
    <p>...</p>
  </mat-tab>
</mat-tab-group>



  </div>
</dashboardnav>

